import CustomerService from '@/services/CustomerService';

// state
const localState = {
  autoLoad: {
    loading: false,
    loader: CustomerService.getAll,
    emptyMap: {}
  },
  customers: {}
};

// getters
const localGetters = {
};

// mutations
const mutations = {
};

// actions
const actions = {
  async postCustomer({ commit }, obj) {
    await CustomerService.postCustomer(obj);
    return true;
  },
};

export default {
  state: localState,
  getters: localGetters,
  mutations,
  actions,
};
